import React, { useState, useRef } from 'react';
import { API } from 'aws-amplify';

import Image from '../../images/user-avatar-80.png';

function SettingsContentAccount({userDetails, authToken, logout}) {

  const [sync, setSync] = useState(false);
  const deleteBtnRef = useRef()
  const [loadingVisible, setLoadingVisible] = useState(false);

  async function deleteAccount(){
    if(authToken!=null && userDetails!=null) {

      deleteBtnRef.current.setAttribute("disabled", true);
      setLoadingVisible(true)

      const apiName = 'DashboardAPI'; // replace this with your api name.
      const path = '/client-user/delete-account'; //replace this with the path you have configured on your API
      const myInit = {
        body: {
          clientUserId: userDetails.id,
          clientId: userDetails.clientId,
          isAdmin: userDetails.id===userDetails.client.adminId,
          userName: userDetails.email
        },
        headers: {
          Authorization: `Bearer ${authToken}`
        }
      };
      API
        .post(apiName, path, myInit)
        .then(response => {
          deleteBtnRef.current.removeAttribute("disabled");
          setLoadingVisible(false)
          logout()
        })
        .catch(error => {
          deleteBtnRef.current.removeAttribute("disabled");
          setLoadingVisible(false)
          logout()
        });
    }
  }

  return (
    <div className="flex-grow shadow-lg">
      {/* Panel body */}
      <div className="p-6 space-y-6">
        <section>
          <h2 className="text-xl text-gray-800 font-bold mb-1">Email</h2>
          <div className="text-sm">The email address we have linked to your EmPushy account.</div>
          <div className="flex flex-wrap mt-5">
            <div className="mr-2">
              <label className="sr-only" htmlFor="email">Business email</label>
              <input id="email" className="form-input disabled:opacity-80" type="email" disabled={true} value={userDetails.email} />
            </div>
          </div>
        </section>
        <section>
          <h2 className="text-xl text-gray-800 font-bold mb-1">Delete Account</h2>
          <div className="text-sm">Permanently delete your account and all associated & synced data. (Note: this cannot be undone.)</div>
          <div className="flex items-center mt-5">
            <button className="btn border-red-300 shadow-sm text-red-500 disabled:opacity-50" onClick={()=> {
              deleteAccount()
            }} ref={deleteBtnRef}>Delete Account</button>
            {loadingVisible?
              <svg className="animate-spin h-6 w-6 ml-4" viewBox="0 0 100 100">
                <circle cx="50" cy="50" r="45" stroke="red" strokeWidth="10" fill="transparent" strokeLinecap="round"
                        strokeDasharray="283" strokeDashoffset="75"/>
              </svg>:''}
          </div>

        </section>
      </div>
    </div>
  );
}

export default SettingsContentAccount;